module.exports = __webpack_public_path__ + "img/HZ-B5006.39dd5180.jpg";